/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategyDescription = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The StrategyDescription model module.
   * @module model/StrategyDescription
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>StrategyDescription</code>.
   * @alias module:model/StrategyDescription
   * @class
   */
  var exports = function() {
    var _this = this;

























  };

  /**
   * Constructs a <code>StrategyDescription</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StrategyDescription} obj Optional instance to populate.
   * @return {module:model/StrategyDescription} The populated <code>StrategyDescription</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('FunctionID')) {
        obj['FunctionID'] = ApiClient.convertToType(data['FunctionID'], 'Integer');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('DateAdded')) {
        obj['DateAdded'] = ApiClient.convertToType(data['DateAdded'], 'Date');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('VisibleToAll')) {
        obj['VisibleToAll'] = ApiClient.convertToType(data['VisibleToAll'], 'Boolean');
      }
      if (data.hasOwnProperty('FatherID')) {
        obj['FatherID'] = ApiClient.convertToType(data['FatherID'], 'Integer');
      }
      if (data.hasOwnProperty('StatusID')) {
        obj['StatusID'] = ApiClient.convertToType(data['StatusID'], 'Integer');
      }
      if (data.hasOwnProperty('ImplementedGoalID')) {
        obj['ImplementedGoalID'] = ApiClient.convertToType(data['ImplementedGoalID'], 'Integer');
      }
      if (data.hasOwnProperty('ImplementedCriticalSuccessFactoryID')) {
        obj['ImplementedCriticalSuccessFactoryID'] = ApiClient.convertToType(data['ImplementedCriticalSuccessFactoryID'], 'Integer');
      }
      if (data.hasOwnProperty('ImplementedMilestoneID')) {
        obj['ImplementedMilestoneID'] = ApiClient.convertToType(data['ImplementedMilestoneID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategyNamingTypeID')) {
        obj['StrategyNamingTypeID'] = ApiClient.convertToType(data['StrategyNamingTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('CustomLabel')) {
        obj['CustomLabel'] = ApiClient.convertToType(data['CustomLabel'], 'String');
      }
      if (data.hasOwnProperty('StrategyDefaultCustomLabel')) {
        obj['StrategyDefaultCustomLabel'] = ApiClient.convertToType(data['StrategyDefaultCustomLabel'], 'String');
      }
      if (data.hasOwnProperty('GoalDefaultCustomLabel')) {
        obj['GoalDefaultCustomLabel'] = ApiClient.convertToType(data['GoalDefaultCustomLabel'], 'String');
      }
      if (data.hasOwnProperty('MilestoneDefaultCustomLabel')) {
        obj['MilestoneDefaultCustomLabel'] = ApiClient.convertToType(data['MilestoneDefaultCustomLabel'], 'String');
      }
      if (data.hasOwnProperty('ProgramDefaultCustomLabel')) {
        obj['ProgramDefaultCustomLabel'] = ApiClient.convertToType(data['ProgramDefaultCustomLabel'], 'String');
      }
      if (data.hasOwnProperty('SubProgramDefaultCustomLabel')) {
        obj['SubProgramDefaultCustomLabel'] = ApiClient.convertToType(data['SubProgramDefaultCustomLabel'], 'String');
      }
      if (data.hasOwnProperty('PublishingTypeID')) {
        obj['PublishingTypeID'] = ApiClient.convertToType(data['PublishingTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('ProgressUpdatesAvailable')) {
        obj['ProgressUpdatesAvailable'] = ApiClient.convertToType(data['ProgressUpdatesAvailable'], 'Boolean');
      }
      if (data.hasOwnProperty('EditableByAll')) {
        obj['EditableByAll'] = ApiClient.convertToType(data['EditableByAll'], 'Boolean');
      }
      if (data.hasOwnProperty('ExcludedFromBusinessReview')) {
        obj['ExcludedFromBusinessReview'] = ApiClient.convertToType(data['ExcludedFromBusinessReview'], 'Boolean');
      }
      if (data.hasOwnProperty('BigPictureGoalPlotBands')) {
        obj['BigPictureGoalPlotBands'] = ApiClient.convertToType(data['BigPictureGoalPlotBands'], 'Boolean');
      }
      if (data.hasOwnProperty('BigPictureCustomFieldID')) {
        obj['BigPictureCustomFieldID'] = ApiClient.convertToType(data['BigPictureCustomFieldID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} FunctionID
   */
  exports.prototype['FunctionID'] = undefined;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Date} DateAdded
   */
  exports.prototype['DateAdded'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Boolean} VisibleToAll
   * @default false
   */
  exports.prototype['VisibleToAll'] = false;
  /**
   * @member {Integer} FatherID
   */
  exports.prototype['FatherID'] = undefined;
  /**
   * @member {Integer} StatusID
   * @default 0
   */
  exports.prototype['StatusID'] = 0;
  /**
   * @member {Integer} ImplementedGoalID
   */
  exports.prototype['ImplementedGoalID'] = undefined;
  /**
   * @member {Integer} ImplementedCriticalSuccessFactoryID
   */
  exports.prototype['ImplementedCriticalSuccessFactoryID'] = undefined;
  /**
   * @member {Integer} ImplementedMilestoneID
   */
  exports.prototype['ImplementedMilestoneID'] = undefined;
  /**
   * @member {Integer} StrategyNamingTypeID
   * @default 0
   */
  exports.prototype['StrategyNamingTypeID'] = 0;
  /**
   * @member {String} CustomLabel
   * @default ''
   */
  exports.prototype['CustomLabel'] = '';
  /**
   * @member {String} StrategyDefaultCustomLabel
   * @default ''
   */
  exports.prototype['StrategyDefaultCustomLabel'] = '';
  /**
   * @member {String} GoalDefaultCustomLabel
   * @default ''
   */
  exports.prototype['GoalDefaultCustomLabel'] = '';
  /**
   * @member {String} MilestoneDefaultCustomLabel
   * @default ''
   */
  exports.prototype['MilestoneDefaultCustomLabel'] = '';
  /**
   * @member {String} ProgramDefaultCustomLabel
   * @default ''
   */
  exports.prototype['ProgramDefaultCustomLabel'] = '';
  /**
   * @member {String} SubProgramDefaultCustomLabel
   * @default ''
   */
  exports.prototype['SubProgramDefaultCustomLabel'] = '';
  /**
   * @member {Integer} PublishingTypeID
   * @default 0
   */
  exports.prototype['PublishingTypeID'] = 0;
  /**
   * @member {Boolean} ProgressUpdatesAvailable
   * @default false
   */
  exports.prototype['ProgressUpdatesAvailable'] = false;
  /**
   * @member {Boolean} EditableByAll
   * @default false
   */
  exports.prototype['EditableByAll'] = false;
  /**
   * @member {Boolean} ExcludedFromBusinessReview
   * @default false
   */
  exports.prototype['ExcludedFromBusinessReview'] = false;
  /**
   * @member {Boolean} BigPictureGoalPlotBands
   * @default false
   */
  exports.prototype['BigPictureGoalPlotBands'] = false;
  /**
   * @member {Integer} BigPictureCustomFieldID
   */
  exports.prototype['BigPictureCustomFieldID'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


